import { snakeToSentenceCase } from "../../utils/string";

/**
 * Tracked `DataPoint.data` keys and their values, e.g. a history entry's old
 * operator, sector and event status.
 */
type HistoryData = Record<string, unknown> | null | undefined;

/** A key the data point didn't have shows as "-" rather than disappearing. */
export const formatHistoryDataValue = (value: unknown): string =>
    value === null || value === undefined || value === "" ? "-" : String(value);

export const historyDataItems = (data: HistoryData) =>
    Object.entries(data ?? {}).map(([key, value]) => ({
        label: snakeToSentenceCase(key),
        value: formatHistoryDataValue(value),
    }));

/**
 * The current values of every key any history entry recorded, so the current
 * version can be read against the old ones.
 */
export const currentTrackedData = (
    current: HistoryData,
    history: { data?: HistoryData }[],
): Record<string, unknown> => {
    const keys = new Set(
        history.flatMap((item) => Object.keys(item.data ?? {})),
    );
    return Object.fromEntries(
        [...keys].map((key) => [key, current?.[key] ?? null]),
    );
};

export const DataPointHistoryDataList = ({ data }: { data: HistoryData }) => {
    const items = historyDataItems(data);
    if (!items.length) {
        return <>-</>;
    }
    return (
        // Keep each line whole: auto-sized tables would otherwise squeeze the
        // column and wrap word by word, making every row tall.
        <div className="flex flex-col whitespace-nowrap">
            {items.map((item) => (
                <span key={item.label}>
                    {item.label}: {item.value}
                </span>
            ))}
        </div>
    );
};
